<template>
    <footer
        class="l-footer"
        v-view.once
    >
        <Wave/>
        <div class="l-grid">
            <div class="l-footer__upper">
                <router-link
                    to="/"
                    class="l-footer__logo"
                    aria-label="Page d'accueil"
                >
                    <Icon
                        icon="logo"
                    />
                </router-link>
                <div class="l-footer__title">
                    <p class="t-t2">
                        Emplacement de vos bureaux:
                        <br>
                        Évaluez l’indice d’écoresponsabilité
                    </p>
                </div>
            </div>
            <div class="l-footer__lower">
                <div class="l-grid__row items-start">
                    <nav class="l-nav-footer | w-full sm:w-1/3 md:w-3/12">
                        <ul class="l-nav-footer__list">
                            <li
                                v-for="item in nav"
                                :key="item.path"
                                class="l-nav-footer__item"
                            >
                                <router-link
                                    v-if="item.type === 'within'"
                                    :key="item.path"
                                    :to="item.path"
                                    exact
                                    class="l-nav-footer__link"
                                >
                                    {{ item.title }}
                                    <span></span>
                                </router-link>
                                <a
                                    v-else
                                    :key="item.path"
                                    :href="item.path"
                                    :title="item.title"
                                    class="l-nav-footer__link"
                                >
                                    {{ item.title }}
                                    <span></span>
                                </a>
                            </li>
                            <li class="l-nav-footer__item l-nav-footer__item--social">
                                <a
                                    v-for="item in social"
                                    :key="item.link"
                                    :href="item.link"
                                    :title="item.label"
                                    class="l-nav-footer__link"
                                    target="_blank"
                                    rel="noopener"
                                >
                                    <Icon
                                        :icon="item.label.toLowerCase()"
                                    />
                                </a>
                            </li>
                        </ul>
                    </nav>
                    <!-- <nav class="l-nav-footer | w-full sm:w-1/2 md:w-5/12">
                        <ul class="l-nav-footer__list">
                            <li
                                v-for="item in navLeft"
                                class="l-nav-footer__item"
                            >
                                <router-link
                                    v-if="item.type == 'within'"
                                    :key="item.path"
                                    :to="item.path"
                                    exact
                                    class="l-nav-footer__link"
                                >
                                    {{ item.title }}
                                    <span></span>
                                </router-link>
                                <a
                                    v-else
                                    :key="item.path"
                                    :href="item.path"
                                    :title="item.title"
                                    class="l-nav-footer__link"
                                >
                                    {{ item.title }}
                                    <span></span>
                                </a>
                            </li>
                        </ul>
                        <ul class="l-nav-footer__list">
                            <li
                                v-for="item in navRight"
                                class="l-nav-footer__item"
                            >
                                <router-link
                                    v-if="item.type == 'within'"
                                    :key="item.path"
                                    :to="item.path"
                                    exact
                                    class="l-nav-footer__link"
                                >
                                    {{ item.title }}
                                    <span></span>
                                </router-link>
                                <a
                                    v-else
                                    :key="item.path"
                                    :href="item.path"
                                    :title="item.title"
                                    class="l-nav-footer__link"
                                >
                                    {{ item.title }}
                                    <span></span>
                                </a>
                            </li>
                            <li class="l-nav-footer__item l-nav-footer__item--social">
                                <a
                                    v-for="item in social"
                                    :href="item.link"
                                    :title="item.label"
                                    class="l-nav-footer__link"
                                    target="_blank"
                                    rel="noopener"
                                >
                                    <Icon
                                        :icon="item.label.toLowerCase()"
                                    />
                                </a>
                            </li>
                        </ul>
                    </nav> -->
                    <div class="w-full xs:w-1/2 sm:w-1/3 md:w-3/12">
                        <h3 class="l-footer__sub | t-s">Une initiative de</h3>
                        <a href="https://vivreenville.org" title="Vivre en Ville" target="_blank" rel="noopener" class="l-footer__link | o-hover-img">
                            <Icon
                                icon="vev"
                            />
                        </a>
                    </div>
                    <div class="w-full xs:w-1/2 sm:w-1/3 md:w-6/12">
                        <Partners
                            :title="partners.title"
                            :partners="partners.partners"
                        >
                        </Partners>
                    </div>
                    <div class="l-footer__credits | t-cms | w-full">
                        <small>
                            &copy;&nbsp;2019 Vivre en Ville.<br>
                            Tous droits réservés.
                        </small>
                        <small>
                            Design et développement web par
                            <a href="https://mambomambo.ca" title="Branding, design et développement web à Québec">MamboMambo</a>.
                        </small>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import Wave from 'templates/objects/Wave';
import Icon from 'templates/objects/Icon';
import Link from 'templates/objects/Link';
import Partners from 'templates/components/Partners';

import LayoutApi from 'services/api/layout';

export default {
    name: 'Footer',
    components: {
        Wave,
        Icon,
        Link,
        Partners,
    },
    data() {
        const navFooter = JSON.parse(JSON.stringify(window.__initialData__.footerNodes));
        return {
            nav: navFooter,
            partners: [],
            social: [],
        };
    },
    props: {
        restaurantIsOpen: {
            type: Boolean,
        },
    },
    created() {
        LayoutApi.getPartners()
            .then((partners) => {
                this.partners = partners.data[0];
            });
        LayoutApi.getSocial()
            .then((social) => {
                this.social = social.data[0][0];
            });
    },
};
</script>
